import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';
import { pageContext } from 'ctm-util-functions';
import { ResultsAnimatedWrapper } from './filters_animated_wrapper/filters_animated_wrapper';

/**
 * The results filters sidebar, with toggle slide in and out animations
 */
class _ResultsFilters extends PureComponent {

    constructor(props) {
        super(props);
        const { isDisplayingResults, compareModeActive, isDisplayingSidebar } = this.props;

        const breakpoint = pageContext.getProps().pageState.breakpoint;
        // filters bar isn't visible when no results or when on xs and sm breakpoints
        let visibility = !(isDisplayingResults || compareModeActive) ? false : !['xs', 'sm'].includes(breakpoint);
        if (breakpoint === 'sm' && !compareModeActive) {
            visibility = isDisplayingSidebar || false;
        }

        this.state = {
            visible: visibility,
            visuallyHidden: !visibility
        };

        // toggle the sidebar with toggleSidebar() in the console
        if (typeof window !== 'undefined') {
            window.toggleSidebar = this.handleToggleClick;
        }
    }

    /**
     * Lifecycle method to update state for new props
     * @param {Object} nextProps - The incoming set of props
     */
    componentWillReceiveProps = (nextProps) => {
        // filters bar isn't visible when no results or when on xs and sm breakpoints
        const visibility = !nextProps.isDisplayingResults || nextProps.compareModeActive ? false : !['xs', 'sm'].includes(nextProps.breakpoint);
        this.setState({
            visible: visibility,
            visuallyHidden: !visibility
        });
        if (nextProps.breakpoint === 'sm' && nextProps.isDisplayingSidebar) {
            this.handleToggleClick();
        }
    };

    /**
     * Flips container visibility state
     * We need a 'visuallyHidden' state as it's impossible to animate display none, the 195 value comes from our
     * animation trait value
     */
    handleToggleClick = () => {
        const { visible } = this.state;
        if (visible) {
            this.setState({ visible: false });
            setTimeout(() => {
                this.setState({ visuallyHidden: true });
            }, 195);
        } else {
            this.setState({ visuallyHidden: false });
            setTimeout(() => {
                this.setState({ visible: true });
            }, 195);
        }
    };

    /**
     * Renders the list of filters and snapshots within collapsible rows
     * @returns {node} the results filter container
     */
    render = () => {
        const { isDisplayingResults, children } = this.props;
        const { visible, visuallyHidden } = this.state;
        return (
            <ResultsAnimatedWrapper isVisible={visible} visuallyHidden={visuallyHidden}>
                { isDisplayingResults ? children : null }
            </ResultsAnimatedWrapper>
        );
    };

}

_ResultsFilters.propTypes = {
    children: PropTypes.array,
    isDisplayingResults: PropTypes.bool,
    compareModeActive: PropTypes.bool,
    isDisplayingSidebar: PropTypes.bool,
    breakpoint: PropTypes.string
};

const mapStateToProps = (state, props) => {
    const resultsConfig = resultsConfigSelector(state);
    const isDisplayingResults = resultsConfig.get('isDisplayingResults');
    const isDisplayingSidebar = resultsConfig.get('isDisplayingSidebar');
    const compareModeActive = resultsConfig.get('compareModeActive');
    const breakpoint = state.get('browser').mediaType;
    return {
        isDisplayingResults,
        isDisplayingSidebar,
        compareModeActive,
        breakpoint
    };
};

const ResultsFilters = connect(mapStateToProps)(_ResultsFilters);

export { ResultsFilters };
